module.exports = __webpack_public_path__ + "static/media/text-predictions.02667104.gif";